export function get_sub_users(state) {
    return state.sub_users;
}
export function get_selected_sub_user(state) {
    return state.sub_users.find(user => user.id == state.selected_sub_user);
}
export function get_selected_user(state) {
    return state.selected_user;
}
export function get_selected_account(state) {
    return state.selected_account;
}
export function get_selected_account_info(state) {
    return state.selected_account_info;
}
export function get_credit_consumption_detail(state) {
    return state.credit_consumption_detail;
}
export function get_right_tab_of_modal(state) {
    return state.right_tab_of_modal;
}
export function get_left_tab_of_modal(state) {
    return state.left_tab_of_modal;
}
